<template>
  <layout-content>
    <div :class="`${need_show_tutorial ? 'overlay-blur' : ''}`"></div>
    <div
      v-if="need_show_tutorial && tutorial_steps[counter].id === 'info'"
      class="general-hint"
      width="585px"
    >
      <div class="general-hint--border flex">
        <img class="mr-4" src="/img/other/info.svg" />
        <span>
          {{ tutorial_steps[counter].text }}
        </span>
      </div>
    </div>
    <div slot="top-buttons" :class="`${need_show_tutorial ? 'tutorial-form' : ''}`">
      <div :class="computed_class" title="Нажмите “Добавить кампанию”">
        <i-button size="large" type="primary" :loading="is_loading" @click="create_button_click">
          {{ $t('autoinformer.breadcrumb.campaign.new') }}
        </i-button>
      </div>
    </div>
    <filter-component />
    <div :class="`${need_show_tutorial ? 'tutorial-form' : ''}`">
      <table-component :hint="tutorial_steps[counter]" :counter="counter" />
    </div>
    <div v-if="need_show_tutorial" :class="`${need_show_tutorial ? 'tutorial-form' : ''}`">
      <div
        class="tutorial-navigation-wrap tutorial-navigation-wrap--close"
        @click="close_tutorial"
      ></div>
    </div>
  </layout-content>
</template>
<script>
  import TableComponent from '@autoinformer/components/campaigns-table.vue';
  import FilterComponent from '@autoinformer/components/campaigns-table-filter.vue';
  import { CampaignsModalService } from '@autoinformer/modals/CampaignsModalService';
  // import { CampaignsService } from '@autoinformer/services/CampaignsService';

  export default {
    components: { TableComponent, FilterComponent },
    data: () => ({
      counter: 0,
      tutorial_steps: [
        {
          id: 'info',
          text:
            'Сервис позволяет без участия операторов обзвонить большую базу клиентов. Система инициирует звонки и при ответе проигрывает клиенту ранее заготовленную аудиозапись, либо IVR меню. Создайте свою первую кампанию.'
        },
        {
          id: 'name',
          text: 'Кликните на название созданной кампании. Чтобы добавить номера на прозвон'
        },
        {
          id: 'status',
          text: 'Ваша кампанию готова, запустите обзвон'
        }
      ],
      is_loading: false,
      need_show_tutorial: false
    }),
    computed: {
      computed_class: function () {
        return this.need_show_tutorial && this.tutorial_steps[this.counter].id === 'info'
          ? 'hint hint--bottom'
          : '';
      },
      is_pbx_allow: function () {
        return this.$permission.module_pbx_is_allowed;
      }
    },
    created() {
      this.need_show_tutorial = !!this.$route.params?.tutorial;
      if (this.$route.params?.counter) {
        this.counter = this.$route.params?.counter;
      }
    },
    methods: {
      close_tutorial() {
        this.need_show_tutorial = false;
      },
      create_button_click: function () {
        if (this.is_pbx_allow) {
          this.$router.push({
            name: 'autoinformer.campaign.new',
            params: { tutorial: this.need_show_tutorial }
          });

          // this.is_loading = true;
          // CampaignsService.createItem()
          //   .then((response) => {

          //     this.$router.push({ name: 'autoinformer.campaign.new', params: { id: response.id } });
          //   })
          //   .catch((error) => {
          //     this.$noty.server_error(error);
          //   })
          //   .finally(() => {
          //     this.is_loading = false;
          //   });
          // this.$router.push({ name: 'autoinformer.campaign.new' });
        } else {
          CampaignsModalService.notice_pbx_module_required().on('success', () =>
            this.$router.push({ name: 'pbx.service-package.index' })
          );
        }
      }
    }
  };
</script>

<style lang="scss">
  .tutorial-form .hint--bottom {
    z-index: 100;

    &:before {
      left: -155px;
      top: -130px;
      transform: rotate(300deg);
    }
    &:after {
      left: -70px;
      top: 170%;
    }
  }
</style>
